import { render, staticRenderFns } from "./withheld.vue?vue&type=template&id=0b174b5c&"
import script from "./withheld.vue?vue&type=script&lang=js&"
export * from "./withheld.vue?vue&type=script&lang=js&"
import style0 from "./withheld.vue?vue&type=style&index=0&id=0b174b5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports